export const PRESERVICE_TEMPLATE_VERSION = 3;
export const PRESERVICE_STATUS_SHEET_NAME = "Student Statuses";

export const PRESERVICE_STATUS_TEMPLATE_HEADERS = [
  "National ID (FAN)",
  "Year of Education",
  "Student Status",
  "GPA",
  "Cumulative GPA",
];

export const STRUCTURED_SHARED_IDENTITY_HEADERS = [
  "Nationality",
  "Ethnicity",
  "Birth Region",
  "Birth Zone",
  "Birth Woreda",
  "Town / Village",
];

const LEGACY_STRUCTURED_STUDENT_HEADERS = [
  "First Name",
  "Father Name",
  "Grand Father Name",
  "Sex",
  "National ID (FAN)",
  ...STRUCTURED_SHARED_IDENTITY_HEADERS,
  "Background Profession",
  "Program Education Type",
  "Department / Discipline",
  "Level Of Study",
  "Year of Entry",
  "Expected Graduation Year",
  "Year of Graduation",
];

const STRUCTURED_STUDENT_HEADERS = [
  ...LEGACY_STRUCTURED_STUDENT_HEADERS.slice(0, 12),
  "Higher Learning Institution",
  ...LEGACY_STRUCTURED_STUDENT_HEADERS.slice(12),
];

const LEGACY_GENERIC_ENTRY_STUDENT_HEADERS = [
  "First Name",
  "Father Name",
  "Grand Father Name",
  "Sex",
  "Date of Birth",
  "National ID (FAN)",
  "Nationality",
  "Ethnicity",
  "Birth Region",
  "Birth Zone",
  "Birth Woreda",
  "Town / Village",
  "Program Education Type",
  "Department / Discipline",
  "Level Of Study",
  "Year of Entry",
  "Expected Graduation Year",
  "Year of Graduation",
];

export const DETAILED_STRUCTURED_TEMPLATE_HEADERS = [
  ...STRUCTURED_STUDENT_HEADERS,
];

export const TVET_TEMPLATE_HEADERS = [...STRUCTURED_STUDENT_HEADERS];

export const GENERIC_ENTRY_TEMPLATE_HEADERS = [
  "First Name",
  "Father Name",
  "Grand Father Name",
  "Sex",
  "Date of Birth",
  "National ID (FAN)",
  "Nationality",
  "Ethnicity",
  "Birth Region",
  "Birth Zone",
  "Birth Woreda",
  "Town / Village",
  "Higher Learning Institution",
  "Program Education Type",
  "Department / Discipline",
  "Level Of Study",
  "Year of Entry",
  "Expected Graduation Year",
  "Year of Graduation",
];

const LEGACY_STATUS_HEADERS = [
  "Year of Education",
  "Student Status",
  "GPA",
  "Cumulative GPA",
];

export const LEGACY_DETAILED_STRUCTURED_TEMPLATE_HEADERS = [
  ...LEGACY_STRUCTURED_STUDENT_HEADERS,
  ...LEGACY_STATUS_HEADERS,
];

export const LEGACY_TVET_TEMPLATE_HEADERS = [
  ...LEGACY_STRUCTURED_STUDENT_HEADERS,
  ...LEGACY_STATUS_HEADERS,
];

export const LEGACY_GENERIC_ENTRY_TEMPLATE_HEADERS = [
  ...LEGACY_GENERIC_ENTRY_STUDENT_HEADERS,
  ...LEGACY_STATUS_HEADERS,
];

const OPTIONAL_STUDENT_HEADERS = new Set(["Year of Graduation"]);

export const getRequiredPreserviceStudentHeaders = (headers = []) =>
  headers.filter((header) => !OPTIONAL_STUDENT_HEADERS.has(header));

export const PRESERVICE_STATUS_REQUIRED_HEADERS = [
  ...PRESERVICE_STATUS_TEMPLATE_HEADERS,
];
